import BlackList from './BlackList';

export default BlackList;
